/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/pendingNotificationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a PendingNotifications. */
export class PendingNotifications {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a PendingNotifications.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls sds service to retrieve pending notification for the specified device
   * @summary Get pending notifications
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.PendingNotificationsGetPendingNotificationsResponse>
   */
  getPendingNotifications(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.PendingNotificationsGetPendingNotificationsResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getPendingNotifications(deviceId: string, callback: coreHttp.ServiceCallback<Models.NotificationResponse[]>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getPendingNotifications(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.NotificationResponse[]>): void;
  getPendingNotifications(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.NotificationResponse[]>, callback?: coreHttp.ServiceCallback<Models.NotificationResponse[]>): Promise<Models.PendingNotificationsGetPendingNotificationsResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getPendingNotificationsOperationSpec,
      callback) as Promise<Models.PendingNotificationsGetPendingNotificationsResponse>;
  }

  /**
   * Calls sds service to delete pending notification for the specified device and request body
   * @summary Delete pending notifications
   * @param deviceId
   * @param body
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  acknowledgeReceipt(deviceId: string, body: Models.AcknowledgmentRequest, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param body
   * @param callback The callback
   */
  acknowledgeReceipt(deviceId: string, body: Models.AcknowledgmentRequest, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param body
   * @param options The optional parameters
   * @param callback The callback
   */
  acknowledgeReceipt(deviceId: string, body: Models.AcknowledgmentRequest, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  acknowledgeReceipt(deviceId: string, body: Models.AcknowledgmentRequest, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        body,
        options
      },
      acknowledgeReceiptOperationSpec,
      callback);
  }

  /**
   * Generate and return the specified toast product recommendation
   * @summary Get toast product recommendation notifications
   * @param deviceId
   * @param type Possible values include: 'MultiDeviceRecommendationSelf',
   * 'MultiDeviceRecommendationFamily', 'VpnRecommendation', 'IntrigueSpam', 'ITMAwareness',
   * 'CMAwareness', 'RewardOffer', 'RewardsSweepstake'
   * @param [options] The optional parameters
   * @returns Promise<Models.PendingNotificationsGetToastProductRecommendationResponse>
   */
  getToastProductRecommendation(deviceId: string, type: Models.ProductRecommendationType, options?: coreHttp.RequestOptionsBase): Promise<Models.PendingNotificationsGetToastProductRecommendationResponse>;
  /**
   * @param deviceId
   * @param type Possible values include: 'MultiDeviceRecommendationSelf',
   * 'MultiDeviceRecommendationFamily', 'VpnRecommendation', 'IntrigueSpam', 'ITMAwareness',
   * 'CMAwareness', 'RewardOffer', 'RewardsSweepstake'
   * @param callback The callback
   */
  getToastProductRecommendation(deviceId: string, type: Models.ProductRecommendationType, callback: coreHttp.ServiceCallback<Models.NotificationResponse[]>): void;
  /**
   * @param deviceId
   * @param type Possible values include: 'MultiDeviceRecommendationSelf',
   * 'MultiDeviceRecommendationFamily', 'VpnRecommendation', 'IntrigueSpam', 'ITMAwareness',
   * 'CMAwareness', 'RewardOffer', 'RewardsSweepstake'
   * @param options The optional parameters
   * @param callback The callback
   */
  getToastProductRecommendation(deviceId: string, type: Models.ProductRecommendationType, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.NotificationResponse[]>): void;
  getToastProductRecommendation(deviceId: string, type: Models.ProductRecommendationType, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.NotificationResponse[]>, callback?: coreHttp.ServiceCallback<Models.NotificationResponse[]>): Promise<Models.PendingNotificationsGetToastProductRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        type,
        options
      },
      getToastProductRecommendationOperationSpec,
      callback) as Promise<Models.PendingNotificationsGetToastProductRecommendationResponse>;
  }

  /**
   * Send toast recommendation to the specified deviceId
   * @summary Send toast product recommendation notifications
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  sendToastProductRecommendation(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  sendToastProductRecommendation(deviceId: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  sendToastProductRecommendation(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  sendToastProductRecommendation(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      sendToastProductRecommendationOperationSpec,
      callback);
  }

  /**
   * Reset toast recommendation properties by removing properties of previously processed toast.
   * @summary Reset toast recommendation properties
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  resetToastRecommendationProperties(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  resetToastRecommendationProperties(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  resetToastRecommendationProperties(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  resetToastRecommendationProperties(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      resetToastRecommendationPropertiesOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getPendingNotificationsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/PendingNotifications/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NotificationResponse"
            }
          }
        }
      }
    },
    404: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const acknowledgeReceiptOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/PendingNotifications/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  requestBody: {
    parameterPath: "body",
    mapper: {
      ...Mappers.AcknowledgmentRequest,
      required: true
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getToastProductRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/PendingNotifications/GenerateToast/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  queryParameters: [
    Parameters.type
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NotificationResponse"
            }
          }
        }
      }
    },
    404: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const sendToastProductRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/PendingNotifications/RecommendationPN/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const resetToastRecommendationPropertiesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/PendingNotifications/reset_toast_recommendation",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
